module.exports = __webpack_public_path__ + "static/media/P4210852.c643fd04.JPG";